<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <custom-date-picker
        v-model="innerValue"
        :error-messages="errors"
        :readonly="readonly"
        :label="label"
        :dense="dense"
        :day-off-dates="dayOffDates"
        :min-selected-date="minSelectedDate"
        :max-selected-date="maxSelectedDate"
        :required-color="requiredColor"
        :required="required"
        @input="change" />
  </ValidationProvider>
</template>

<script>
  import CustomDatePicker from './CustomDatePicker.vue'
  export default {
    components: {
      CustomDatePicker
    },
    props: {
      value: {
        type: String,
        default: null
      },
      rules: [String, Object],
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      dense: {
        type: Boolean,
        default: false
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      errorMessages: Array,
      minSelectedDate: {
        type: String,
        default: '1991-01-01'
      },
      maxSelectedDate: {
        type: String
      },
      dayOffDates: Array,
      vid: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        innerValue: null
      }
    },
    computed: {
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') && !!this.rules.length && this.rules.includes('required'))
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newVal) {
          if (newVal !== this.innerValue) {
            this.innerValue = newVal
          }
        }
      }
      // innerValue (val) {
      //   this.$emit('input', val)
      // }
    },
    methods: {
      change: function (value) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
</script>
